/**
 * Announcements Domain Menu Provider
 */

import {
  IconDashboard,
  IconList,
  IconMapPin,
  IconCalendarEvent,
  IconSettings,
  IconDatabase,
  IconChartBar,
} from '@tabler/icons-react';
import { DomainMenuProvider, MenuSection } from '../../layouts/menu/types';
import { createVisibilityCheck } from './BaseMenuProvider';
import { useAnnouncementBadgesStore } from '@/domain/badges/announcementBadgesStore';

class AnnouncementsMenuProvider implements DomainMenuProvider {
  domainId = 'announcements';

  getMenuConfig() {
    const sections: MenuSection[] = [
      // Overview Section
      {
        id: 'announcements-overview',
        label: 'Overview',
        items: [
          {
            id: 'announcements-dashboard',
            label: 'Dashboard',
            path: '/app/announcements',
            icon: <IconDashboard size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
            countSelector: () => useAnnouncementBadgesStore.getState().upcoming || null,
            badgeColor: 'blue',
          },
        ],
      },

      // Management Section
      {
        id: 'announcements-management',
        label: 'Management',
        items: [
          {
            id: 'announcements-list',
            label: 'Announcements',
            path: '/app/announcements/list',
            icon: <IconList size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
            countSelector: () => useAnnouncementBadgesStore.getState().drafts || null,
            badgeColor: 'yellow',
          },
          {
            id: 'announcements-locations',
            label: 'Locations',
            path: '/app/announcements/locations',
            icon: <IconMapPin size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
          {
            id: 'announcements-events',
            label: 'Events',
            path: '/app/announcements/events',
            icon: <IconCalendarEvent size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
        ],
      },

      // Insights Section
      {
        id: 'announcements-insights',
        label: 'Insights',
        items: [
          {
            id: 'announcements-analytics',
            label: 'Analytics',
            path: '/app/announcements/analytics',
            icon: <IconChartBar size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
        ],
      },

      // Settings Section
      {
        id: 'announcements-settings',
        label: 'Settings',
        items: [
          {
            id: 'announcements-admin',
            label: 'Admin',
            path: '/app/announcements/admin',
            icon: <IconSettings size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
          {
            id: 'announcements-lookups',
            label: 'Lookups',
            path: '/app/announcements/admin/lookups',
            icon: <IconDatabase size={16} />,
            visible: createVisibilityCheck({ roles: ['Admin'] }),
          },
        ],
      },
    ];

    return {
      domainId: this.domainId,
      sections,
      metadata: {
        version: '1.0.0',
        lastUpdated: Date.now(),
      },
    };
  }
}

export const announcementsMenuProvider = new AnnouncementsMenuProvider();
